export default __webpack_public_path__ + "static/media/complementary--obstacle-delineator--g1.2be98597.png";